import { DEFAULT_PAGE_SIZE_PROJECTS_SHORT_ENTITIES } from '@/lib/constants/pagination';
import { getShortClients } from '@/modules/clients/api/clients.api';
import { NON_ARCHIVED_CLIENT_STATUSES } from '@/modules/clients/types/request/find-short-clients.request';
import { DropdownSearchItem } from '@/modules/common/components/molecules/selectors/dropdown';
import { PaginatedResponse } from '@/modules/common/types/pagination-types';
import { getShortTeamMembers } from '@/modules/team/api/team.api';
import { NON_ARCHIVED_TEAM_MEMBER_STATUSES } from '@/modules/team/types/dto/find-short-team-members.request';

/**
 * Hook providing data loading functions for project info selectors
 * (clients and managers with pagination support)
 */
export function useProjectSelectors() {
  /**
   * Load clients for selector with pagination
   */
  const loadClients = async (
    cursor?: number | null
  ): Promise<PaginatedResponse<DropdownSearchItem>> => {
    return getShortClients({
      filter: { statuses: NON_ARCHIVED_CLIENT_STATUSES },
      pagination: { cursor, pageSize: DEFAULT_PAGE_SIZE_PROJECTS_SHORT_ENTITIES },
    });
  };

  /**
   * Search clients for selector with pagination
   */
  const searchClients = async (
    searchTerm: string,
    cursor?: number | null
  ): Promise<PaginatedResponse<DropdownSearchItem>> => {
    return getShortClients({
      filter: { searchString: searchTerm, statuses: NON_ARCHIVED_CLIENT_STATUSES },
      pagination: { cursor, pageSize: DEFAULT_PAGE_SIZE_PROJECTS_SHORT_ENTITIES },
    });
  };

  /**
   * Load managers for selector with pagination
   */
  const loadManagers = async (
    cursor?: number | null
  ): Promise<PaginatedResponse<DropdownSearchItem>> => {
    return getShortTeamMembers({
      filter: { isManager: true, statuses: NON_ARCHIVED_TEAM_MEMBER_STATUSES },
      pagination: { cursor, pageSize: DEFAULT_PAGE_SIZE_PROJECTS_SHORT_ENTITIES },
    });
  };

  /**
   * Search managers for selector with pagination
   */
  const searchManagers = async (
    searchTerm: string,
    cursor?: number | null
  ): Promise<PaginatedResponse<DropdownSearchItem>> => {
    return getShortTeamMembers({
      filter: {
        searchString: searchTerm,
        isManager: true,
        statuses: NON_ARCHIVED_TEAM_MEMBER_STATUSES,
      },
      pagination: { cursor, pageSize: DEFAULT_PAGE_SIZE_PROJECTS_SHORT_ENTITIES },
    });
  };

  return {
    loadClients,
    searchClients,
    loadManagers,
    searchManagers,
  };
}
